"use client";
import React from "react";
import SectionTitle from "@/components/Common/SectionTitle";
import CalendlyEmbed from "@/components/CalendlyEmbed";


const Contact = () => {

    return (
        <section id="contact" className="text-class overflow-hidden py-10">
            <div className="container">
                <SectionTitle
                    title="Let's Talk"
                    paragraph="Book a demo with us to know more about our products and services"
                    mb={"0"}
                    center
                    center_sm
                />
                <CalendlyEmbed/>
            </div>
        </section>
    );
};

export default Contact;
